// extracted by mini-css-extract-plugin
module.exports = {"tagsForm":"TagsForm_tagsForm__1jYgr","title":"TagsForm_title__2oTw7"};